import { render, staticRenderFns } from "./CampaignChecks.vue?vue&type=template&id=1cb94ca6"
import script from "./CampaignChecks.vue?vue&type=script&lang=js"
export * from "./CampaignChecks.vue?vue&type=script&lang=js"
import style0 from "./CampaignChecks.vue?vue&type=style&index=0&id=1cb94ca6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports